import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class ExpiryCheckQualifier {
    phase = CouponApplyPhase.PreApply;
    _data;
    _dependencies;
    constructor(dependencies, sourceData) {
        this._data = sourceData;
        this._dependencies = dependencies;
    }
    _isExpired(coupon) {
        if (coupon.expiryDate == null)
            return false;
        const now = new Date();
        const expiry = new Date(coupon.expiryDate);
        // Compare dates only (ignore time)
        now.setHours(0, 0, 0, 0);
        expiry.setHours(0, 0, 0, 0);
        return now > expiry;
    }
    _checkSchedule(schedules, cart) {
        let promiseDate;
        let dayOfWeek = 0;
        let promiseMinutes = 0;
        if (cart.futureDate && cart.futureMinute != null) {
            promiseDate = new Date(cart.futureDate);
            dayOfWeek = promiseDate.getDay();
            promiseMinutes = cart.futureMinute;
        }
        else {
            promiseDate = this._data.tempNow ?? this._dependencies.nowStore(this._data.timeOffset);
            const promiseBDate = new Date(this._dependencies.getBusDate(promiseDate, this._data.timeOffset, this._data.settings.BSM));
            dayOfWeek = promiseBDate.getDay();
            promiseMinutes = promiseDate.getMinutes() + (60 * promiseDate.getHours());
        }
        return schedules.some(schedule => {
            return schedule.weekDayNumber === dayOfWeek && schedule.isActive && schedule.startDayMinute <= promiseMinutes && schedule.endDayMinute >= promiseMinutes;
        });
    }
    qualify(coupon, cart) {
        if (this._isExpired(coupon)) {
            return { isValid: false, errorCode: CouponApplyErrorCode.NOT_VALID_TODAY };
        }
        if (coupon.schedules.length > 0) {
            const result = this._checkSchedule(coupon.schedules, cart);
            if (!result) {
                return { isValid: false, errorCode: CouponApplyErrorCode.NOT_VALID_TODAY };
            }
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=expiry-check.js.map